/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppTodayRouteImport } from './routes/_app.today'
import { Route as AppTargetsRouteImport } from './routes/_app.targets'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppOpportunitiesRouteImport } from './routes/_app.opportunities'
import { Route as AppLoansRouteImport } from './routes/_app.loans'
import { Route as AppHistoryRouteImport } from './routes/_app.history'
import { Route as AppTargetsIndexRouteImport } from './routes/_app.targets.index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app.settings.index'
import { Route as AppLoansIndexRouteImport } from './routes/_app.loans.index'
import { Route as AppTargetsKeyRouteImport } from './routes/_app.targets.$key'
import { Route as AppSettingsUsersRouteImport } from './routes/_app.settings.users'
import { Route as AppSettingsScheduleRouteImport } from './routes/_app.settings.schedule'
import { Route as AppSettingsMeRouteImport } from './routes/_app.settings.me'
import { Route as AppSettingsMarketsRouteImport } from './routes/_app.settings.markets'
import { Route as AppSettingsLendersRouteImport } from './routes/_app.settings.lenders'
import { Route as AppSettingsIcpRouteImport } from './routes/_app.settings.icp'
import { Route as AppSettingsDynamoTermsRouteImport } from './routes/_app.settings.dynamo-terms'
import { Route as AppSettingsAuditRouteImport } from './routes/_app.settings.audit'
import { Route as AppSettingsApiUsageRouteImport } from './routes/_app.settings.api-usage'
import { Route as AppLoansIdRouteImport } from './routes/_app.loans.$id'
import { Route as AppTargetsKeyIndexRouteImport } from './routes/_app.targets.$key.index'
import { Route as AppSettingsMarketsIndexRouteImport } from './routes/_app.settings.markets.index'
import { Route as AppLoansIdIndexRouteImport } from './routes/_app.loans.$id.index'
import { Route as AppSettingsMarketsIdRouteImport } from './routes/_app.settings.markets.$id'
import { Route as AppLoansIdPdfRouteImport } from './routes/_app.loans.$id.pdf'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTodayRoute = AppTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AppRoute,
} as any)
const AppTargetsRoute = AppTargetsRouteImport.update({
  id: '/targets',
  path: '/targets',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppOpportunitiesRoute = AppOpportunitiesRouteImport.update({
  id: '/opportunities',
  path: '/opportunities',
  getParentRoute: () => AppRoute,
} as any)
const AppLoansRoute = AppLoansRouteImport.update({
  id: '/loans',
  path: '/loans',
  getParentRoute: () => AppRoute,
} as any)
const AppHistoryRoute = AppHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AppRoute,
} as any)
const AppTargetsIndexRoute = AppTargetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTargetsRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppLoansIndexRoute = AppLoansIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLoansRoute,
} as any)
const AppTargetsKeyRoute = AppTargetsKeyRouteImport.update({
  id: '/$key',
  path: '/$key',
  getParentRoute: () => AppTargetsRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsScheduleRoute = AppSettingsScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMeRoute = AppSettingsMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMarketsRoute = AppSettingsMarketsRouteImport.update({
  id: '/markets',
  path: '/markets',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsLendersRoute = AppSettingsLendersRouteImport.update({
  id: '/lenders',
  path: '/lenders',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsIcpRoute = AppSettingsIcpRouteImport.update({
  id: '/icp',
  path: '/icp',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDynamoTermsRoute = AppSettingsDynamoTermsRouteImport.update({
  id: '/dynamo-terms',
  path: '/dynamo-terms',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAuditRoute = AppSettingsAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsApiUsageRoute = AppSettingsApiUsageRouteImport.update({
  id: '/api-usage',
  path: '/api-usage',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppLoansIdRoute = AppLoansIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppLoansRoute,
} as any)
const AppTargetsKeyIndexRoute = AppTargetsKeyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTargetsKeyRoute,
} as any)
const AppSettingsMarketsIndexRoute = AppSettingsMarketsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsMarketsRoute,
} as any)
const AppLoansIdIndexRoute = AppLoansIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLoansIdRoute,
} as any)
const AppSettingsMarketsIdRoute = AppSettingsMarketsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppSettingsMarketsRoute,
} as any)
const AppLoansIdPdfRoute = AppLoansIdPdfRouteImport.update({
  id: '/pdf',
  path: '/pdf',
  getParentRoute: () => AppLoansIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/history': typeof AppHistoryRoute
  '/loans': typeof AppLoansRouteWithChildren
  '/opportunities': typeof AppOpportunitiesRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/targets': typeof AppTargetsRouteWithChildren
  '/today': typeof AppTodayRoute
  '/loans/$id': typeof AppLoansIdRouteWithChildren
  '/settings/api-usage': typeof AppSettingsApiUsageRoute
  '/settings/audit': typeof AppSettingsAuditRoute
  '/settings/dynamo-terms': typeof AppSettingsDynamoTermsRoute
  '/settings/icp': typeof AppSettingsIcpRoute
  '/settings/lenders': typeof AppSettingsLendersRoute
  '/settings/markets': typeof AppSettingsMarketsRouteWithChildren
  '/settings/me': typeof AppSettingsMeRoute
  '/settings/schedule': typeof AppSettingsScheduleRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/targets/$key': typeof AppTargetsKeyRouteWithChildren
  '/loans/': typeof AppLoansIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/targets/': typeof AppTargetsIndexRoute
  '/loans/$id/pdf': typeof AppLoansIdPdfRoute
  '/settings/markets/$id': typeof AppSettingsMarketsIdRoute
  '/loans/$id/': typeof AppLoansIdIndexRoute
  '/settings/markets/': typeof AppSettingsMarketsIndexRoute
  '/targets/$key/': typeof AppTargetsKeyIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/history': typeof AppHistoryRoute
  '/opportunities': typeof AppOpportunitiesRoute
  '/today': typeof AppTodayRoute
  '/settings/api-usage': typeof AppSettingsApiUsageRoute
  '/settings/audit': typeof AppSettingsAuditRoute
  '/settings/dynamo-terms': typeof AppSettingsDynamoTermsRoute
  '/settings/icp': typeof AppSettingsIcpRoute
  '/settings/lenders': typeof AppSettingsLendersRoute
  '/settings/me': typeof AppSettingsMeRoute
  '/settings/schedule': typeof AppSettingsScheduleRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/loans': typeof AppLoansIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/targets': typeof AppTargetsIndexRoute
  '/loans/$id/pdf': typeof AppLoansIdPdfRoute
  '/settings/markets/$id': typeof AppSettingsMarketsIdRoute
  '/loans/$id': typeof AppLoansIdIndexRoute
  '/settings/markets': typeof AppSettingsMarketsIndexRoute
  '/targets/$key': typeof AppTargetsKeyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/history': typeof AppHistoryRoute
  '/_app/loans': typeof AppLoansRouteWithChildren
  '/_app/opportunities': typeof AppOpportunitiesRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/targets': typeof AppTargetsRouteWithChildren
  '/_app/today': typeof AppTodayRoute
  '/_app/loans/$id': typeof AppLoansIdRouteWithChildren
  '/_app/settings/api-usage': typeof AppSettingsApiUsageRoute
  '/_app/settings/audit': typeof AppSettingsAuditRoute
  '/_app/settings/dynamo-terms': typeof AppSettingsDynamoTermsRoute
  '/_app/settings/icp': typeof AppSettingsIcpRoute
  '/_app/settings/lenders': typeof AppSettingsLendersRoute
  '/_app/settings/markets': typeof AppSettingsMarketsRouteWithChildren
  '/_app/settings/me': typeof AppSettingsMeRoute
  '/_app/settings/schedule': typeof AppSettingsScheduleRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/targets/$key': typeof AppTargetsKeyRouteWithChildren
  '/_app/loans/': typeof AppLoansIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/targets/': typeof AppTargetsIndexRoute
  '/_app/loans/$id/pdf': typeof AppLoansIdPdfRoute
  '/_app/settings/markets/$id': typeof AppSettingsMarketsIdRoute
  '/_app/loans/$id/': typeof AppLoansIdIndexRoute
  '/_app/settings/markets/': typeof AppSettingsMarketsIndexRoute
  '/_app/targets/$key/': typeof AppTargetsKeyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/history'
    | '/loans'
    | '/opportunities'
    | '/settings'
    | '/targets'
    | '/today'
    | '/loans/$id'
    | '/settings/api-usage'
    | '/settings/audit'
    | '/settings/dynamo-terms'
    | '/settings/icp'
    | '/settings/lenders'
    | '/settings/markets'
    | '/settings/me'
    | '/settings/schedule'
    | '/settings/users'
    | '/targets/$key'
    | '/loans/'
    | '/settings/'
    | '/targets/'
    | '/loans/$id/pdf'
    | '/settings/markets/$id'
    | '/loans/$id/'
    | '/settings/markets/'
    | '/targets/$key/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/history'
    | '/opportunities'
    | '/today'
    | '/settings/api-usage'
    | '/settings/audit'
    | '/settings/dynamo-terms'
    | '/settings/icp'
    | '/settings/lenders'
    | '/settings/me'
    | '/settings/schedule'
    | '/settings/users'
    | '/loans'
    | '/settings'
    | '/targets'
    | '/loans/$id/pdf'
    | '/settings/markets/$id'
    | '/loans/$id'
    | '/settings/markets'
    | '/targets/$key'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/history'
    | '/_app/loans'
    | '/_app/opportunities'
    | '/_app/settings'
    | '/_app/targets'
    | '/_app/today'
    | '/_app/loans/$id'
    | '/_app/settings/api-usage'
    | '/_app/settings/audit'
    | '/_app/settings/dynamo-terms'
    | '/_app/settings/icp'
    | '/_app/settings/lenders'
    | '/_app/settings/markets'
    | '/_app/settings/me'
    | '/_app/settings/schedule'
    | '/_app/settings/users'
    | '/_app/targets/$key'
    | '/_app/loans/'
    | '/_app/settings/'
    | '/_app/targets/'
    | '/_app/loans/$id/pdf'
    | '/_app/settings/markets/$id'
    | '/_app/loans/$id/'
    | '/_app/settings/markets/'
    | '/_app/targets/$key/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/today': {
      id: '/_app/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AppTodayRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/targets': {
      id: '/_app/targets'
      path: '/targets'
      fullPath: '/targets'
      preLoaderRoute: typeof AppTargetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/opportunities': {
      id: '/_app/opportunities'
      path: '/opportunities'
      fullPath: '/opportunities'
      preLoaderRoute: typeof AppOpportunitiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/loans': {
      id: '/_app/loans'
      path: '/loans'
      fullPath: '/loans'
      preLoaderRoute: typeof AppLoansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/history': {
      id: '/_app/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AppHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/targets/': {
      id: '/_app/targets/'
      path: '/'
      fullPath: '/targets/'
      preLoaderRoute: typeof AppTargetsIndexRouteImport
      parentRoute: typeof AppTargetsRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/loans/': {
      id: '/_app/loans/'
      path: '/'
      fullPath: '/loans/'
      preLoaderRoute: typeof AppLoansIndexRouteImport
      parentRoute: typeof AppLoansRoute
    }
    '/_app/targets/$key': {
      id: '/_app/targets/$key'
      path: '/$key'
      fullPath: '/targets/$key'
      preLoaderRoute: typeof AppTargetsKeyRouteImport
      parentRoute: typeof AppTargetsRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/schedule': {
      id: '/_app/settings/schedule'
      path: '/schedule'
      fullPath: '/settings/schedule'
      preLoaderRoute: typeof AppSettingsScheduleRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/me': {
      id: '/_app/settings/me'
      path: '/me'
      fullPath: '/settings/me'
      preLoaderRoute: typeof AppSettingsMeRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/markets': {
      id: '/_app/settings/markets'
      path: '/markets'
      fullPath: '/settings/markets'
      preLoaderRoute: typeof AppSettingsMarketsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/lenders': {
      id: '/_app/settings/lenders'
      path: '/lenders'
      fullPath: '/settings/lenders'
      preLoaderRoute: typeof AppSettingsLendersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/icp': {
      id: '/_app/settings/icp'
      path: '/icp'
      fullPath: '/settings/icp'
      preLoaderRoute: typeof AppSettingsIcpRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/dynamo-terms': {
      id: '/_app/settings/dynamo-terms'
      path: '/dynamo-terms'
      fullPath: '/settings/dynamo-terms'
      preLoaderRoute: typeof AppSettingsDynamoTermsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/audit': {
      id: '/_app/settings/audit'
      path: '/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof AppSettingsAuditRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/api-usage': {
      id: '/_app/settings/api-usage'
      path: '/api-usage'
      fullPath: '/settings/api-usage'
      preLoaderRoute: typeof AppSettingsApiUsageRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/loans/$id': {
      id: '/_app/loans/$id'
      path: '/$id'
      fullPath: '/loans/$id'
      preLoaderRoute: typeof AppLoansIdRouteImport
      parentRoute: typeof AppLoansRoute
    }
    '/_app/targets/$key/': {
      id: '/_app/targets/$key/'
      path: '/'
      fullPath: '/targets/$key/'
      preLoaderRoute: typeof AppTargetsKeyIndexRouteImport
      parentRoute: typeof AppTargetsKeyRoute
    }
    '/_app/settings/markets/': {
      id: '/_app/settings/markets/'
      path: '/'
      fullPath: '/settings/markets/'
      preLoaderRoute: typeof AppSettingsMarketsIndexRouteImport
      parentRoute: typeof AppSettingsMarketsRoute
    }
    '/_app/loans/$id/': {
      id: '/_app/loans/$id/'
      path: '/'
      fullPath: '/loans/$id/'
      preLoaderRoute: typeof AppLoansIdIndexRouteImport
      parentRoute: typeof AppLoansIdRoute
    }
    '/_app/settings/markets/$id': {
      id: '/_app/settings/markets/$id'
      path: '/$id'
      fullPath: '/settings/markets/$id'
      preLoaderRoute: typeof AppSettingsMarketsIdRouteImport
      parentRoute: typeof AppSettingsMarketsRoute
    }
    '/_app/loans/$id/pdf': {
      id: '/_app/loans/$id/pdf'
      path: '/pdf'
      fullPath: '/loans/$id/pdf'
      preLoaderRoute: typeof AppLoansIdPdfRouteImport
      parentRoute: typeof AppLoansIdRoute
    }
  }
}

interface AppLoansIdRouteChildren {
  AppLoansIdPdfRoute: typeof AppLoansIdPdfRoute
  AppLoansIdIndexRoute: typeof AppLoansIdIndexRoute
}

const AppLoansIdRouteChildren: AppLoansIdRouteChildren = {
  AppLoansIdPdfRoute: AppLoansIdPdfRoute,
  AppLoansIdIndexRoute: AppLoansIdIndexRoute,
}

const AppLoansIdRouteWithChildren = AppLoansIdRoute._addFileChildren(
  AppLoansIdRouteChildren,
)

interface AppLoansRouteChildren {
  AppLoansIdRoute: typeof AppLoansIdRouteWithChildren
  AppLoansIndexRoute: typeof AppLoansIndexRoute
}

const AppLoansRouteChildren: AppLoansRouteChildren = {
  AppLoansIdRoute: AppLoansIdRouteWithChildren,
  AppLoansIndexRoute: AppLoansIndexRoute,
}

const AppLoansRouteWithChildren = AppLoansRoute._addFileChildren(
  AppLoansRouteChildren,
)

interface AppSettingsMarketsRouteChildren {
  AppSettingsMarketsIdRoute: typeof AppSettingsMarketsIdRoute
  AppSettingsMarketsIndexRoute: typeof AppSettingsMarketsIndexRoute
}

const AppSettingsMarketsRouteChildren: AppSettingsMarketsRouteChildren = {
  AppSettingsMarketsIdRoute: AppSettingsMarketsIdRoute,
  AppSettingsMarketsIndexRoute: AppSettingsMarketsIndexRoute,
}

const AppSettingsMarketsRouteWithChildren =
  AppSettingsMarketsRoute._addFileChildren(AppSettingsMarketsRouteChildren)

interface AppSettingsRouteChildren {
  AppSettingsApiUsageRoute: typeof AppSettingsApiUsageRoute
  AppSettingsAuditRoute: typeof AppSettingsAuditRoute
  AppSettingsDynamoTermsRoute: typeof AppSettingsDynamoTermsRoute
  AppSettingsIcpRoute: typeof AppSettingsIcpRoute
  AppSettingsLendersRoute: typeof AppSettingsLendersRoute
  AppSettingsMarketsRoute: typeof AppSettingsMarketsRouteWithChildren
  AppSettingsMeRoute: typeof AppSettingsMeRoute
  AppSettingsScheduleRoute: typeof AppSettingsScheduleRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsApiUsageRoute: AppSettingsApiUsageRoute,
  AppSettingsAuditRoute: AppSettingsAuditRoute,
  AppSettingsDynamoTermsRoute: AppSettingsDynamoTermsRoute,
  AppSettingsIcpRoute: AppSettingsIcpRoute,
  AppSettingsLendersRoute: AppSettingsLendersRoute,
  AppSettingsMarketsRoute: AppSettingsMarketsRouteWithChildren,
  AppSettingsMeRoute: AppSettingsMeRoute,
  AppSettingsScheduleRoute: AppSettingsScheduleRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppTargetsKeyRouteChildren {
  AppTargetsKeyIndexRoute: typeof AppTargetsKeyIndexRoute
}

const AppTargetsKeyRouteChildren: AppTargetsKeyRouteChildren = {
  AppTargetsKeyIndexRoute: AppTargetsKeyIndexRoute,
}

const AppTargetsKeyRouteWithChildren = AppTargetsKeyRoute._addFileChildren(
  AppTargetsKeyRouteChildren,
)

interface AppTargetsRouteChildren {
  AppTargetsKeyRoute: typeof AppTargetsKeyRouteWithChildren
  AppTargetsIndexRoute: typeof AppTargetsIndexRoute
}

const AppTargetsRouteChildren: AppTargetsRouteChildren = {
  AppTargetsKeyRoute: AppTargetsKeyRouteWithChildren,
  AppTargetsIndexRoute: AppTargetsIndexRoute,
}

const AppTargetsRouteWithChildren = AppTargetsRoute._addFileChildren(
  AppTargetsRouteChildren,
)

interface AppRouteChildren {
  AppHistoryRoute: typeof AppHistoryRoute
  AppLoansRoute: typeof AppLoansRouteWithChildren
  AppOpportunitiesRoute: typeof AppOpportunitiesRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTargetsRoute: typeof AppTargetsRouteWithChildren
  AppTodayRoute: typeof AppTodayRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppHistoryRoute: AppHistoryRoute,
  AppLoansRoute: AppLoansRouteWithChildren,
  AppOpportunitiesRoute: AppOpportunitiesRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTargetsRoute: AppTargetsRouteWithChildren,
  AppTodayRoute: AppTodayRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
